/**
 * Route Constants
 * Alla routes i DQFleet
 */

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/',
  LIVE_TRACKING: '/live-tracking',
  FLEET: '/fleet',
  FLEET_OVERVIEW: '/fleet/overview',
  FLEET_UNPLUG_EVENTS: '/fleet/unplug-events',
  FLEET_ECONOMY_EXPORT: '/fleet/economy-export',
  FLEET_COST_INVOICES: '/fleet/cost-invoices',
  FLEET_VEHICLE_ECONOMY: '/fleet/vehicle-economy',
  FLEET_DASHBOARD: '/fleet',
  REPORTS: '/reports',
  SYSTEM_REPORTS: '/reports',
  SYSTEM_FLEET: '/fleet',
  /** Bokningssystemets kortsida (moduler); inte kalendersidan */
  SYSTEM_BOOKING: '/system/booking',
  BOOKING_OLD_BOOKING: '/booking/old-booking',
  BOOKING_BOOKINGS_SEARCH: '/booking/bookings-search',
  BOOKING_OPTIMIZATION: '/booking/optimization',
  BOOKING_RESOURCES: '/booking/resources',
  BOOKING_BASIS: '/booking/bokningsunderlag',
  /** Analys-systemets kortsida (moduler). Saknad /analysis går till hem. */
  SYSTEM_ANALYSIS: '/system/analysis',
  SYSTEM_ADMINISTRATION: '/admin',
  SERVICE: '/service',
  REPORTS_TRIPS: '/reports/trips',
  REPORTS_ECO_DRIVING: '/reports/eco-driving',
  REPORTS_SPEED_COMPLIANCE: '/reports/speed-compliance',
  REPORTS_ENERGY_CONSUMPTION: '/reports/energy-consumption',
  REPORTS_VEHICLE_WEAR: '/reports/vehicle-wear',
  REPORTS_UNDERUTILIZED: '/reports/underutilized-vehicles',
  REPORTS_CO2: '/reports/co2',
  REPORTS_BOOKING_STATS: '/reports/booking-stats',
  REPORTS_GEOFENCE_ZONES: '/reports/geofence-zones',
  REPORTS_DRIVING_LOG: '/reports/driving-log',
  REPORTS_ODOMETER: '/reports/odometer',
  REPORTS_RENTAL: '/reports/rental',
  REPORTS_VEHICLE_KPI: '/reports/vehicle-kpi',
  REPORTS_DTC: '/reports/dtc',
  REPORTS_SERVICE_COSTS: '/reports/service-costs',
  REPORTS_FUEL_ANALYSIS: '/reports/fuel-analysis',
  REPORTS_FLEET_TCO: '/reports/fleet-tco',
  REPORTS_EXECUTIVE: '/reports/executive',
  ANALYSIS_HEATMAP: '/analysis/heatmap',
  ANALYSIS_TRENDS: '/analysis/trends',
  ANALYSIS_BENCHMARKS: '/analysis/benchmarks',
  ANALYSIS_AI: '/analysis/ai',
  ANALYSIS_ROUTE: '/analysis/route',
  /** Modulöversikt för arbetsorder-systemet (kort: Hantverkare, Leverans, …) */
  WORK_ORDERS: '/system/workorder',
  SYSTEM_WORKORDER: '/system/workorder',
  WORK_ORDERS_CRAFTSMAN: '/work-orders/craftsman',
  WORK_ORDERS_DELIVERY: '/work-orders/delivery',
  WORK_ORDERS_HOMECARE: '/work-orders/homecare',
  WORK_ORDERS_SERVICE_AGREEMENTS: '/work-orders/service-agreements',
  SYSADMIN_AI_LOG: '/admin/sysadmin/ai-log',
  
  // Deque System
  SYSTEM_DEQUE: '/system/deque',
  DEQUE_MAP_SERVICES: '/system/deque/map-services',
  DEQUE_TRACK: '/system/deque/track',
  DEQUE_FUEL_MANAGEMENT: '/system/deque/fuel-management',
  DEQUE_FUEL_CARDS: '/system/deque/fuel-cards',
  DEQUE_ASSIGNMENTS: '/system/deque/assignments',
  DEQUE_VEHICLE_LOG: '/system/deque/vehicle-log',
  DEQUE_REPLACEMENT_CHAIN: '/system/deque/replacement-chain',
  DEQUE_VEHICLE_CATEGORIES: '/system/deque/vehicle-categories',
  DEQUE_ALTERNATIVE_FUELS: '/system/deque/alternative-fuels',
  DEQUE_CHARGING: '/system/deque/charging',
  DEQUE_VEHICLE_USAGE_STATUSES: '/system/deque/usage-statuses',
  STATISTICS: '/statistics',
  VEHICLES: '/vehicles',
  PROFILE: '/profile',
  ORGANIZATION: '/organization',
  ORGANIZATION_CHART: '/organization/chart',
  ADMIN: '/admin',
  ADMIN_ROLES: '/admin/roles',
  SYSADMIN_ROLES: '/admin/sysadmin/roles',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_USERS: '/admin/users',
  ADMIN_TRANSLATIONS: '/admin/translations',
  ADMIN_IMPORTS: '/admin/imports',
  ADMIN_PACKAGES: '/admin/packages',
  ADMIN_DEVICES: '/admin/devices',
  ADMIN_DEVICE_MANAGEMENT: '/admin/device-management',
  ADMIN_DEVICE_AVL_CAPABILITIES: '/admin/device-avl-capabilities',
  ADMIN_OBD_VEHICLES: '/admin/obd-vehicles',
  ADMIN_OBD_KNOWLEDGE: '/admin/obd-knowledge',
  ADMIN_SIM_CARDS: '/admin/sim-cards',
  ADMIN_GEOFENCES: '/admin/geofences',
  ADMIN_GEOFENCE_EVENTS: '/admin/geofence-events',
  ADMIN_FLINKEY_BOXES: '/admin/flinkey-boxes',
  ADMIN_SUPPORT: '/admin/support',
  ADMIN_CARINFO_ORG_SYNC: '/admin/carinfo-org-sync',
  SYSADMIN: '/admin/sysadmin',
  SYSADMIN_DATA_MIGRATION: '/admin/sysadmin/data-migration',
  SYSADMIN_DEVICE_COMMANDS: '/admin/sysadmin/device-commands',
  ADMIN_FOTA_MIGRATION: '/admin/fota-migration',
  ADMIN_THEME_SETTINGS: '/admin/theme-settings',
  SYSADMIN_AUDIT_LOG: '/admin/sysadmin/audit-log',
  SYSADMIN_GENERAL_AUDIT_LOG: '/admin/sysadmin/general-audit-log',
  SYSADMIN_ERROR_LOG: '/admin/sysadmin/error-log',
  SYSADMIN_ECO_SETTINGS: '/admin/sysadmin/eco-settings',
  SYSADMIN_SYSTEM_MONITOR: '/admin/sysadmin/system-monitor',
  SYSADMIN_SLOW_QUERIES: '/admin/sysadmin/slow-queries',
  SYSADMIN_CERTIFICATE_MONITOR: '/admin/sysadmin/certificate-monitor',
  SYSADMIN_SECURITY: '/admin/sysadmin/security',
  SYSADMIN_SSO_LOG: '/admin/sysadmin/sso-log',
  SYSADMIN_GPS_DATA_LAG: '/admin/sysadmin/gps-data-lag',
  SYSADMIN_DEVICE_QUEUES: '/admin/sysadmin/device-queues',
  SYSADMIN_DATA_REPLAY: '/admin/sysadmin/data-replay',
  SYSADMIN_IMPORT_SOURCES: '/admin/sysadmin/import-sources',
  SYSADMIN_TRIP_SYNC: '/admin/sysadmin/trip-sync',
  SYSADMIN_VEHICLE_CARINFO_SYNC: '/admin/sysadmin/vehicle-carinfo-sync',
  USER_MANUAL: '/manual',
  TEST_RUNNER: '/testing',
  
  // CRM
  CRM: '/crm',
  CRM_CUSTOMERS: '/crm/customers',
  CRM_CUSTOMER_WIZARD: '/crm/customers/new',
  CRM_PROJECTS: '/crm/projects',
  CRM_PROCUREMENTS: '/crm/procurements',
  CRM_PIPELINE: '/crm/pipeline',
  CRM_ECONOMY_OVERVIEW: '/crm/economy',
  CRM_INVOICES: '/crm/invoices',
  CRM_PRICELIST: '/crm/pricelist',
  CRM_MODULE_CATALOG: '/crm/module-catalog',
  CRM_SCB_TESTING: '/crm/scb-testing',
  DEV_PROJECTS: '/admin/dev-projects',
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/auth/verify-email',
} as const;
